module.exports = __webpack_public_path__ + "static/img/bg-1.ab45ef7d.jpg";